export function openClassroomTab(path: string) {
  window.open(path, '_blank', 'noopener,noreferrer');
}
